<template>
  <button class="graphical-button" @click="handleClick">
    <span class="button-label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'GraphicalButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    iconAlt: {
      type: String,
      default: 'Button Icon',
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped>
.graphical-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #254182;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.graphical-button:hover {
  background-color: #4B71BF
}

.button-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.button-label {
  display: inline;
}
</style>
